import request from '@/util/request';
import qs from 'qs';


export const documentList = (params, options) =>
  request.get(
    '/api/nursing/document/list',
    Object.assign({}, options, { params })
  );
  export const documentUpload= (params, options) =>
  request.post('/api/nursing/document/upload', params, options);